import { Box, Button } from '@mui/material';
import React, { useState } from 'react';
import RenderHTML from '../../../components/preview/RenderHTML';
import PopUpTextEditor from '../../../components/popup/PopUpTextEditor';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { API_PATCH, DBRequest, useConfig } from '../../../api/api';

export const SalesObjectLevelText = ({
  text,
  levelId,
  onChange,
  isEditMode,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [openEditor, setOpenEditor] = useState(false);
  function handleChange(data) {
    DBRequest({
      config,
      path: `sales-object-levels/${levelId}`,
      method: API_PATCH({ description: data }),
      onResponse: onChange,
    });
  }
  if (!isEditMode)
    return (
      <Box sx={{ padding: '5px 10px' }}>
        <RenderHTML HTML={text} emptyHTML={' '} />
      </Box>
    );
  return (
    <>
      <Button
        onClick={() => setOpenEditor(true)}
        sx={{
          padding: '5px 10px',
          justifyContent: 'start',
          textAlign: 'left',
        }}
        variant="outlined"
        className="w-full"
      >
        {text ? (
          <RenderHTML HTML={text} emptyHTML={' '} />
        ) : (
          <>
            <AddIcon className="mr-1" />
            {t('Add Text')}
          </>
        )}
      </Button>
      <PopUpTextEditor
        startHTML={text}
        open={openEditor}
        onClose={() => setOpenEditor(false)}
        onSave={handleChange}
      />
    </>
  );
};
